var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.BlockTitle, {
        staticClass: "mb-8",
        attrs: { title: _setup.t("Отзывы врачей", _setup.options) },
      }),
      _vm._v(" "),
      _c(_setup.CoreSwiper, {
        scopedSlots: _vm._u([
          {
            key: "slides",
            fn: function ({ slideAttrs, swiperInstance }) {
              return _vm._l(_vm.doctorReviews, function (doctorReview) {
                return _c(
                  "div",
                  _vm._b(
                    {
                      key: doctorReview.id,
                      staticClass: "border rounded-sm text-center py-6",
                    },
                    "div",
                    slideAttrs,
                    false
                  ),
                  [
                    _c(_setup.DoctorReviewSlide, {
                      attrs: {
                        "doctor-review": doctorReview,
                        "swiper-instance": swiperInstance,
                      },
                    }),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }